<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> vip管理 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.game_id" placeholder="游戏id" style="width: 200px"></el-input>
          <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
          <el-button class="filter-item" type="success" @click="handleCreate">添加</el-button>
        </div>

        <el-table border min-height="200" max-height="1000" v-loading="listLoading" :data="tableData" style="width: 100%">
          <el-table-column prop="game_name" label="游戏名称" />
          <el-table-column prop="money" label="金额" />
          <el-table-column prop="login_days" label="累计登陆天数" />
          <el-table-column prop="created_at" label="提交时间" sortable></el-table-column>
          <el-table-column label="操作" width="260" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
              <el-popover placement="top" width="160" v-model="scope.row.deleteVisible">
                <p>确定删除吗?</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="handleDelete(scope.row)">确定</el-button>
                </div>
                <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete">删除</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleList" />
        <el-dialog :title="popupTitle" center width="60%" :visible.sync="dialogFormVisible" @close="closeDialog" :close-on-click-modal="addControl">
          <el-form :model="formData" style="margin-left: 50px">
            <el-form-item label="ID" :label-width="formLabelWidth" v-if="idShow">
              <el-col :span="8">
                <el-input v-model="formData.id" :disabled="idDisabled"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="游戏" multiple :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select v-model="formData.game_id" filterable multiple placeholder="请选择" :reserve-keyword="true">
                  <el-option v-for="item in gameData" :key="item.index" :label="item.game_name" :value="item.game_id.toString()"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="金额" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.money"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="累计登陆天数" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.login_days"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="图片" :label-width="formLabelWidth">
              <el-upload
                v-model="formData.images"
                :action="apiUrl"
                list-type="picture-card"
                drag
                multiple
                :file-list="getStableImageFileList('images', files)"
                :headers="file_headers"
                :on-preview="handlePreview"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                :on-change="handleUploadChange"
                :on-error="handleUploadError"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogImageVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeAdd">取 消</el-button>
            <el-button type="primary" @click="handleCreateUpdateStore">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { handleListApi, handleCreateStoreApi, handleDeleteApi, handleGetGameApi } from '@/api/work_game_vips.js';
import Pagination from '@/components/pagination/index';
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { appendImageInSelectionOrder, imageUploadMixin, normalizeImageList, removeImageByUploadFile } from '@/utils/imageUpload.js';
export default {
  mixins: [imageUploadMixin],
  components: { Pagination },
  name: 'work_game_vips',
  data() {
    return {
      gameData: [],
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 10,
      },
      //图片上传
      // apiUrl:'http://worksn.hzwxbz2.cn/api/v1/admin/work_upload',
      apiUrl: BASE_API + 'admin/work_upload_admin',
      dialogImageUrl: '',
      files: [],
      dialogImageVisible: false,
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken(),
      },
      // 添加数据的缓存。
      addData: {},
      addCheck: 0,
      popupTitle: '',
      // 表单
      dialogFormVisible: false,
      idDisabled: true,
      idShow: false,
      formData: {
        money: '',
        game_id: [],
        login_days: '',
      },
      formLabelWidth: '120px',
    };
  },
  created() {
    this.handleList(this.listQuery);
    this.handleGetGame();
  },
  computed: {
    addControl() {
      let item = true;
      if (this.popupTitle == '添加') {
        item = false;
      }
      return item;
    },
  },
  methods: {
    handleList() {
      this.listLoading = true;
      handleListApi(this.listQuery)
        .then((response) => {
          const data = response.data.data;
          this.tableData = data;
          this.total = response.data.total;
          setTimeout(() => {
            this.listLoading = false;
          }, 0.5 * 1000);
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    //获取游戏列表
    handleGetGame() {
      handleGetGameApi()
        .then((response) => {
          this.gameData = response.data;
        })
        .catch((error) => {});
    },
    handleCreate() {
      this.resetImageUploadScope('images');
      this.popupTitle = '添加';
      this.idShow = false;
      this.handleResetForm();
      if (this.addCheck == 1) {
        this.formData = JSON.parse(JSON.stringify(this.addData));
        this.files = this.formData.images;
      }
      this.dialogFormVisible = true;
    },
    closeDialog() {
      if (this.popupTitle == '添加' && (this.addCheck == 0 || this.addCheck == 1)) {
        this.addData = JSON.parse(JSON.stringify(this.formData));
        this.addCheck = 1;
      }
      if (this.popupTitle == '添加' && this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
    },
    handleUpdate(row) {
      this.resetImageUploadScope('images');
      this.popupTitle = '修改';
      this.idShow = true;
      this.dialogFormVisible = true;
      this.formData.id = row.id;
      this.formData.game_id = row.game_id.split(',');
      this.formData.money = row.money;
      this.formData.login_days = row.login_days;
      this.formData.images = normalizeImageList(row.images, 'vip');
      this.files = this.formData.images;
    },
    handleDelete(row) {
      handleDeleteApi(row)
        .then((response) => {
          this.$message.success('操作成功');
          row.deleteVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    handleResetForm() {
      this.resetImageUploadScope('images');
      this.formData.id = '';
      this.formData.money = '';
      this.formData.login_days = '';
      this.formData.game_id = [];
      this.formData.images = [];
      this.files = [];
      this.dialogFormVisible = false;
    },
    removeAdd() {
      this.dialogFormVisible = false;
    },
    handleCreateUpdateStore() {
      if (!this.guardImageUploads(['images'])) return;
      handleCreateStoreApi(this.formData)
        .then((response) => {
          this.$message.success('操作成功');
          if (this.formData.id == '') {
            this.addCheck = 2;
          }
          this.dialogFormVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    handleUploadChange(file, fileList) {
      this.trackImageUpload('images', file, fileList);
    },
    handleRemove(file, fileList) {
      this.files = removeImageByUploadFile(this.files, file);
      this.formData.images = this.files;
      this.removeTrackedImage('images', file, fileList);
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },
    handleSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.files = appendImageInSelectionOrder(this.files, file, { url: response.data.path, name: response.data.name || file.name });
        this.formData.images = this.files;
        this.trackImageUpload('images', file, fileList);
        this.$message.success(response.message);
      }
    },
    handleUploadError(error, file, fileList) {
      if (!this.isCurrentImageUpload('images', file)) return;
      this.trackImageUpload('images', file, fileList);
      this.$message.error(`${file.name || '图片'}上传失败`);
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.handleList(this.listQuery);
    },
  },
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
